<template>
  <div
    role="status"
    class="animate-pulse w-full border border-gray-200 pt-4 px-4 md:pt-5 md:px-6 rounded-lg "
  >
    <div
      v-for="n in rows"
      :key="n"
      class="flex gap-y-4 gap-x-2 mb-4"
    >
      <div class="h-[24px] bg-gray-200 rounded-lg w-1/3 lg:w-1/4" />
      <div class="h-[24px] bg-gray-200 rounded-lg w-2/3 lg:w-3/4" />
    </div>
    <span class="sr-only">Loading...</span>
  </div>
</template>

<script lang="ts">
export default { name: 'DetailsLoader' }
</script>
<script setup lang="ts">
withDefaults(
  defineProps<{
    rows?: number
  }>(), {
    rows: 3,
  },
)
</script>
